import { createStateRenderer } from "../../../../data/fieldRenderers/State";
import { getStateBackgroundColor, getStateTextColor } from "../utils";

const renderer = createStateRenderer(
  getStateTextColor,
  getStateBackgroundColor,
);

export default renderer;
